import React from "react";
import styled from "styled-components";

import { SupportNumber, P } from "commons";

export function Support() {
    return (
        <Container data-testid="support-details">
            <P>
                If you need any help, please click on the live chat button, or call us on{" "}
                <SupportNumber secondary />.
            </P>
            <P>
                Support is available from 8:30am to 5:30pm Monday to Friday (excluding bank
                holidays).
            </P>
        </Container>
    );
}

export const Container = styled.div`
    text-align: left;
    max-width: 280px;
    margin-top: 2em;
`;
